import React from "react";
import style from "./BesoinAideQuest.module.css";

function BesoinAideQuest(props) {
  return (
    <div className={style.budgetQuestion}>
      <p>{props.title}</p>
      <p>{props.subTitle}</p>
      <div className={style.purpleBar}></div>
    </div>
  );
}

export default BesoinAideQuest;
